import Image from "next/image";
import SatelliteImagery from "assets/img/landing/SatelliteImagery.png";
import GroundSensors from "assets/img/landing/sensors.png";
import Farmlogs from "assets/img/landing/files.png";
import DataAnalysis from "assets/img/landing/brain.png";
import { useTranslation } from "react-i18next";

function index() {
  const { t, i18n } = useTranslation();
  return (
    <div
      className="bg-[#F2F6EC] py-15 px-5 xl:px-5 overflow-x-hidden"
      id="About"
    >
      <div className="container m-auto">
        <div className="text-3xl font-bold text-center">
          {t("OUR TECHNOLOGY")}
        </div>
        <div className="flex flex-wrap items-center justify-center mt-15 lg:flex-nowrap lg:justify-between gap-15 ">
          <div
            className={` lg:w-[60%] w-full text-center md:text-left ${
              i18n.language === "en" ? "md:text-left" : "md:text-right"
            }`}
          >
            <div className="text-[#6da728] font-bold text-2xl">
              {t("PLATFARM")}
            </div>
            <div className="text-[#6da728] font-bold my-2 ">
              {t(
                "PLATFARM builds farm’s digital twin to enable data-driven agriculture for MENA region."
              )}
            </div>
            <div className="text-[#717171]">{t("firstDescription")}</div>
          </div>
          <div>
            <div className="flex items-center w-full gap-2 text-center md:gap-5">
              <div className="bg-white p-5 rounded-lg w-32 h-32 flex flex-col gap-1 items-center justify-center mt-[4rem]">
                <div>
                  <Image
                    priority={true}
                    quality={30}
                    src={DataAnalysis}
                    alt="img"
                  />
                </div>
                <div className="text-[#6da728] font-bold">
                  {i18n.language === "en" ? (
                    <>
                      AI & Data
                      <br /> Analysis
                    </>
                  ) : (
                    <>الذكاء الإصطناعي</>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-5">
                <div className="flex flex-col items-center justify-center w-32 h-32 gap-1 p-5 bg-white rounded-lg">
                  <div>
                    <Image
                      priority={true}
                      quality={30}
                      src={SatelliteImagery}
                      alt="img"
                    />
                  </div>
                  <div className="text-[#6da728] font-bold">
                    {i18n.language === "en" ? (
                      <>
                        Satellite
                        <br /> Imagery
                      </>
                    ) : (
                      <>صور الأقمار الصناعية</>
                    )}
                  </div>
                </div>
                <div className="flex flex-col items-center justify-center w-32 h-32 gap-1 p-5 bg-white rounded-lg">
                  <div>
                    <Image
                      priority={true}
                      quality={30}
                      src={GroundSensors}
                      alt="img"
                    />
                  </div>
                  <div className="text-[#6da728] font-bold">
                    {i18n.language === "en" ? (
                      <>
                        Ground
                        <br /> Sensors
                      </>
                    ) : (
                      <>الحساسات الأرضية</>
                    )}
                  </div>
                </div>
              </div>
              <div className="bg-white p-5 rounded-lg w-32 h-32 flex flex-col gap-1 items-center justify-center -mt-[4rem]">
                <div>
                  <Image
                    priority={true}
                    quality={30}
                    src={Farmlogs}
                    alt="img"
                  />
                </div>
                <div className="text-[#6da728] font-bold">
                  {" "}
                  {i18n.language === "en" ? <>Farm logs</> : <>سجلات المزرعة</>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
